import { Link } from "react-router-dom";
import { Phone, ArrowRight } from "lucide-react";
import { business } from "@/data/site";

export default function CtaBand({ kicker, title, text, showEstimate = true }) {
  return (
    <section className="relative grain bg-navy" data-testid="cta-band">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 md:py-16 relative">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8">
          <div className="max-w-2xl">
            {kicker && (
              <p className="font-accent uppercase tracking-[0.25em] text-sm text-cream/80 mb-2">
                {kicker}
              </p>
            )}
            <h2 className="font-heading text-4xl sm:text-5xl uppercase text-cream leading-[0.95]">
              {title}
            </h2>
            {text && <p className="mt-4 text-cream/85 leading-relaxed">{text}</p>}
          </div>
          <div className="flex flex-col sm:flex-row gap-4 shrink-0">
            <a
              href={business.phoneHref}
              data-testid="ctaband-call"
              className="flex items-center justify-center gap-2 bg-cream text-charcoal border border-charcoal/20 shadow-md hover:-translate-y-1 hover:shadow-lg transition-all font-heading text-xl uppercase px-7 py-4"
            >
              <Phone className="w-5 h-5" />
              Call {business.phone}
            </a>
            {showEstimate && (
              <Link
                to="/contact"
                data-testid="ctaband-estimate"
                className="flex items-center justify-center gap-2 bg-gold text-charcoal border border-charcoal/20 shadow-md hover:-translate-y-1 hover:shadow-lg transition-all font-heading text-xl uppercase px-7 py-4"
              >
                Free Estimate
                <ArrowRight className="w-5 h-5" />
              </Link>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
